// extracted by mini-css-extract-plugin
module.exports = {"augurDetailsSettings":"styles_augurDetailsSettings__10KQc","settingsButtons":"styles_settingsButtons__1X1iC"};